import { render, staticRenderFns } from "./FilterManageButton.vue?vue&type=template&id=7b871776&scoped=true&"
import script from "./FilterManageButton.vue?vue&type=script&lang=ts&"
export * from "./FilterManageButton.vue?vue&type=script&lang=ts&"
import style0 from "./FilterManageButton.vue?vue&type=style&index=0&id=7b871776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b871776",
  null
  
)

export default component.exports
import {QBtn,QIcon,QBadge} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QIcon,QBadge})
